// Module
var code = "<div insurance=\"'profile'\"></div>";
// Exports
var _module_exports = code;;
var path = 'template/settings/tabs/profile-insurance.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;